// *****************************************************
// Swiper
// *****************************************************
import Swiper, {
  Navigation,
  EffectFade,
  Thumbs,
  Autoplay,
  Pagination,
  SwiperOptions,
} from "swiper";

// *****************************************************
// Swiper操作クラス
// *****************************************************
export class SwiperOperate {
  constructor() {
    Swiper.use([Navigation, EffectFade, Thumbs, Autoplay, Pagination]);

    // ****** トップページ MV ******
    const topMvParams: SwiperOptions = {
      loop: true, // 一番最後まで行ったときに最初に戻る（true）か戻らない（false）か
      autoplay: {
        // 自動再生
        delay: 7000, // 間隔（ミリ秒）
        disableOnInteraction: true, // 操作されたら自動再生をストップさせる（true）設定（規定値true）
      },
      slidesPerView: 1.16, // 1画面に表示するスライドの枚数
      centeredSlides: true, // アクティブなスライドを中央にする
      spaceBetween: 10, // スライド同士の距離（px）
      speed: 400, // スライドが移動する時間（ミリ秒）（規定値は300ms）
      autoHeight: false, // スライド毎の高さに合わせる
      // ナビゲーションボタン（前に戻るボタン、次に進むボタン）
      navigation: {
        nextEl: ".swiperMvNextBtn",
        prevEl: ".swiperMvPrevBtn",
      },
      // ページネーション
      pagination: {
        el: ".swiper-pagination",
        clickable: true, //クリックに反応させる
      },
      breakpoints: {
        // スライドの表示枚数：769px以上の場合
        769: {
          spaceBetween: 20, // スライド同士の距離（px）
        },
      },
    };
    const topMv = new Swiper(".topMvSwiper", topMvParams);

    // ****** トップページ 事例紹介 ******
    const topWorksParams: SwiperOptions = {
      loop: true, // 一番最後まで行ったときに最初に戻る（true）か戻らない（false）か
      autoplay: {
        // 自動再生
        delay: 7000, // 間隔（ミリ秒）
        disableOnInteraction: true, // 操作されたら自動再生をストップさせる（true）設定（規定値true）
      },
      slidesPerView: 1.5, // 1画面に表示するスライドの枚数
      centeredSlides: true, // アクティブなスライドを中央にする
      spaceBetween: 10, // スライド同士の距離（px）
      speed: 400, // スライドが移動する時間（ミリ秒）（規定値は300ms）
      autoHeight: false, // スライド毎の高さに合わせる
      // ナビゲーションボタン（前に戻るボタン、次に進むボタン）
      navigation: {
        nextEl: ".topWorksSwiperContainer .swiperNextBtn",
        prevEl: ".topWorksSwiperContainer .swiperPrevBtn",
      },
      breakpoints: {
        // スライドの表示枚数：769px以上の場合
        769: {
          slidesPerView: 3, // 1画面に表示するスライドの枚数
          centeredSlides: false, // アクティブなスライドを中央にする
          spaceBetween: 20, // スライド同士の距離（px）
        },
      },
    };
    const topWorks = new Swiper(".topWorksSwiper", topWorksParams);

    // ****** サムネイル有りの画像スライダー ******
    // サムネイル
    const sliderThumbnail = new Swiper(".thumbSlider", {
      slidesPerView: 5, // サムネイルの枚数
      threshold: 20,
      spaceBetween: 10,
      // ナビゲーションボタン（前に戻るボタン、次に進むボタン）
      navigation: {
        nextEl: ".thumbSlider_next",
        prevEl: ".thumbSlider_prev",
      },
    });
    // スライダー
    const slider = new Swiper(".pictureSlider", {
      effect: "fade", // フェード
      speed: 100,
      slidesPerView: 1, // 1画面に表示するスライドの枚数
      autoplay: {
        // 自動再生
        delay: 6000, // 間隔（ミリ秒）
        disableOnInteraction: true, // 操作されたら自動再生をストップさせる（true）設定（規定値true）
      },
      // ナビゲーションボタン（前に戻るボタン、次に進むボタン）
      navigation: {
        nextEl: ".pictureSlider_next",
        prevEl: ".pictureSlider_prev",
      },
      thumbs: {
        swiper: sliderThumbnail,
      },
    });
  }
}
